<template>
  <form @submit.prevent="login" class="grid-container">
    <BaseInput
      type="email"
      label="Email"
      name="email"
      v-model="email"
      autocomplete="email"
      class="mb-2"
    />
    <BaseInput
      type="password"
      label="Password"
      name="password"
      v-model="password"
      class="mb-4"
    />
    <span class="flex justify-between">
      <BaseBtn type="submit" text="Login" />
      <br />
      Forgot your password?
      <router-link to="/forgot-password" class="text-sm base-link">
        Reset.
      </router-link>
    </span>
    <FlashMessage :error="error" />
  </form>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router'; // Import useRouter
import { getError } from "../utils/helpers";
import BaseBtn from "./BaseBtn";
import BaseInput from "./BaseInput";
import AuthService from "../services/AuthService";
import FlashMessage from "./FlashMessage";

export default {
  name: "LoginForm",
  components: {
    BaseBtn,
    BaseInput,
    FlashMessage
  },
  setup() {
    const email = ref("");
    const password = ref("");
    const error = ref(null);
    const router = useRouter(); // Use useRouter to get the router instance

    const login = async () => {
      const payload = {
        email: email.value,
        password: password.value,
      };

      try {
        await AuthService.login(payload);
        // Navigate to dashboard upon successful login
        router.push("/dashboard"); // Use router instead of this.$router
      } catch (err) {
        // Handle error using getError
        error.value = getError(err);
      }
    };

    return {
      email,
      password,
      error,
      login
    };
  },
};
</script>
